import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

import { FaAddressBook, FaGift } from "react-icons/fa";
import { MdFavorite, MdLogout, MdNotifications } from "react-icons/md";
import { AiOutlineRight } from "react-icons/ai";
import { BsBoxSeam, BsPerson } from "react-icons/bs";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem("username") || "User";

  // ⭐ ACTIVE TAB STATE
  const [activeTab, setActiveTab] = useState("profile");

  const handleNavigate = (path, tab) => {
    setActiveTab(tab);
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  return (
    <>
      <Navbar />

      <div className="bg-gray-100 min-h-screen py-8">
        <div className="max-w-6xl mx-auto flex gap-4 pl-1 px-0.5">

          {/* LEFT → USER CARD + SIDEBAR */}
          <div className="w-80 flex flex-col gap-4">

            {/* USER CARD */}
            <div className="bg-white rounded-lg shadow border p-5 flex items-center gap-4">
              <div className="w-16 h-14 rounded-full bg-yellow-400 flex items-center justify-center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2922/2922532.png"
                  alt="avatar"
                  className="w-11 h-11"
                />
              </div>
              <div>
                <p className="text-gray-500 text-sm">Hello,</p>
                <p className="text-xl font-semibold text-gray-900">{userName}</p>
              </div>
            </div>

            {/* SIDEBAR */}
            <aside className="bg-white rounded-lg shadow border ml-1">

              {/* MY ORDERS */}
              <div
                onClick={() => handleNavigate("/orders", "orders")}
                className={`p-4 flex justify-between items-center font-semibold cursor-pointer 
                  ${activeTab === "orders" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <span className="flex items-center gap-3">
                  <BsBoxSeam className="text-blue-600 text-lg" />
                  My Orders
                </span>
                <AiOutlineRight className="text-gray-500" />
              </div>

              <div className="border-b"></div>

              {/* ACCOUNT SETTINGS */}
              <p className="px-4 pt-4 pb-2 text-gray-500 text-sm font-semibold">
                ACCOUNT SETTINGS
              </p>

              {/* PROFILE */}
              <div
                onClick={() => handleNavigate("/dashboard/profile", "profile")}
                className={`px-4 py-3 pl-6 flex items-center gap-3 cursor-pointer 
                  ${activeTab === "profile" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <BsPerson className="text-blue-600 text-lg" />
                Profile Information
              </div>

              {/* ADDRESS */}
              <div
                onClick={() => handleNavigate("/dashboard/address", "address")}
                className={`px-4 py-3 pl-6 flex items-center gap-3 cursor-pointer 
                  ${activeTab === "address" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <FaAddressBook className="text-gray-600 text-lg" />
                Manage Address
              </div>

              {/* MY STUFF */}
              <p className="px-4 pt-4 pb-2 text-gray-500 text-sm font-semibold border-t">
                MY STUFF
              </p>

              {/* COUPONS */}
              <div
                onClick={() => handleNavigate("/dashboard/coupons", "coupons")}
                className={`px-4 py-3 pl-6 flex items-center gap-3 cursor-pointer 
                  ${activeTab === "coupons" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <FaGift className="text-gray-600" />
                My Coupons
              </div>

              {/* WISHLIST */}
              <div
                onClick={() => handleNavigate("/dashboard/wishlist", "wishlist")}
                className={`px-4 py-3 pl-6 flex items-center gap-3 cursor-pointer 
                  ${activeTab === "wishlist" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <MdFavorite className="text-gray-600" />
                My Wishlist
              </div>

              {/* NOTIFICATIONS */}
              <div
                onClick={() => handleNavigate("/dashboard/notifications", "notifications")}
                className={`px-4 py-3 pl-6 flex items-center gap-3 cursor-pointer 
                  ${activeTab === "notifications" ? "bg-blue-50 border-l-4 border-blue-600 text-blue-700" : "hover:bg-gray-50"}
                `}
              >
                <MdNotifications className="text-gray-600" />
                Notifications
              </div>

              {/* LOGOUT */}
              <div
                onClick={handleLogout}
                className="px-4 py-4 border-t cursor-pointer flex gap-3 text-red-600 font-semibold hover:bg-gray-50"
              >
                <MdLogout className="text-xl" /> Logout
              </div>

            </aside>
          </div>

          {/* RIGHT CONTENT AREA */}
          <main className="flex-1 bg-white rounded-lg shadow border p-6">
            <Outlet />
          </main>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default DashboardLayout;
